<style lang="scss" src='./TaskActivity.scss' scoped></style>
<template src="./TaskActivity.html"></template>

<script>
import UserAvatar from '@/components/user/avatar/UserAvatar.vue';

export default {
  components: {
    UserAvatar,
  },

  props: {
    activity: {
      type: Object,
      required: true,
    },
    deleteComment: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
    };
  },

  methods: {},

};
</script>

<style>

</style>
